import type Result from 'true-myth/result';

import type { HttpFetcherError } from '~/shared/http-fetcher/http-fetcher';
import type { ValidatingHttpFetcherWithBaseUrl } from '~/shared/validating-http-fetcher';

import type { AlignmentRecordDetails } from '../alignment-record/store/alignment-record-schema';
import { alignmentRecordDetailsSchema } from '../alignment-record/store/alignment-record-schema';

export type FetchAlignmentRecordPayload = {
    readonly alignmentRecordId: string;
    readonly employeeId: string;
};

export type FetchAlignmentRecord = (
    payload: FetchAlignmentRecordPayload,
) => Promise<Result<AlignmentRecordDetails, HttpFetcherError>>;

export const createFetchAlignmentRecord = (
    validatingHttpFetcher: ValidatingHttpFetcherWithBaseUrl,
): FetchAlignmentRecord => {
    const fetchAlignmentRecord: FetchAlignmentRecord = async ({ alignmentRecordId, employeeId }) => {
        return validatingHttpFetcher.get(alignmentRecordDetailsSchema, {
            pathname: `/users/${employeeId}/alignment-records/${alignmentRecordId}`,
        });
    };

    return fetchAlignmentRecord;
};
